var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-content"},[_c('img',{attrs:{"src":require("../../assets/images/baby_mike.jpg")}}),_c('div',[_vm._v("yikes")])])
}]

export { render, staticRenderFns }